import {Heading} from '@sanity/ui'
import {createGlobalStyle, styled} from 'styled-components'
import {PropsWithChildren} from 'react'

// See: https://github.com/sanity-io/sanity/blob/0021c2a5c064534d38c624984a234c8ee154c815/packages/sanity/src/core/form/inputs/PortableText/text/textStyles.tsx#L36

const TextContainer = styled.div`
  display: block;
  &:before {
    content: 'Q: ';
    display: inline-block;
  }
`

const GlobalStyles = createGlobalStyle`
  div[data-style='h2-question'] + div[data-block-type="text"] > div > [data-ui="Box"]:first-child  span [data-slate-node="text"]:first-of-type {
    &:before {
        content: 'A: ';
        display: inline-block;
        font-weight: bold;
    }
  }
`

const H2Question: React.FC<PropsWithChildren> = ({children}) => (
  <>
    <GlobalStyles />
    <Heading as="h2" data-testid="text-style--h2" size={4}>
      <TextContainer>{children}</TextContainer>
    </Heading>
  </>
)

export default H2Question
